import React from 'react';

const CaQuizToutView = (props) => {
    const { header,title,description, image, cta, ctaCallback } = props;
    return(
        <div className={"QuizTout"}>
            <div className="QuizTout__hr"></div>
            <div className={"QuizTout__outer-grid"}>
                <div className={"QuizTout__text-wrapper"}>
                    <h2 className="QuizTout__header">{header}</h2>
                    <h3 className="QuizTout__title">{title}</h3>
                    <p className="QuizTout__text">{description}</p>
                    <div className={"QuizTout__buttonWrapper"}>
                        <button className={"QuizTout__submitButton"} onClick={()=>ctaCallback()}>{cta}</button>
                    </div>
                </div>
                <div className={"QuizTout__image-wrapper"}>
                    <img className="QuizTout__image" src={image}/>
                </div>
            </div>
            <div className="QuizTout__hr"></div>
        </div>
    );
};
export default CaQuizToutView;
